module.exports = "<app-upload-control (fileAdded)=\"setFileData($event)\"></app-upload-control>\n<div (click)=\"signedURL()\" class=\"submit-btn\">\n    <button mat-button>Submit</button>\n</div>\n\n<div class=\"submit-btn\">\n    <button mat-button>DownloadDocument</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/upload-control-test/upload-control-test.component.html
// module id = ./src/app/components/upload-control-test/upload-control-test.component.html
// module chunks = main